import { render, staticRenderFns } from "./WebHookForm.vue?vue&type=template&id=252884e6"
import script from "./WebHookForm.vue?vue&type=script&lang=js"
export * from "./WebHookForm.vue?vue&type=script&lang=js"
import style0 from "./WebHookForm.vue?vue&type=style&index=0&id=252884e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports